import { getActivityInfoByApi } from '@efe-activity-fe-util/core'

export function useBackstage() {
    let activityConfig:
        | Awaited<ReturnType<typeof getActivityInfoByApi>>['data']
        | null = null

    const getActivityConfig = async () => {
        const { data } = await getActivityInfoByApi('payType')

        try {
            data.activityMsgConfig.activityMsg.context = JSON.parse(
                data.activityMsgConfig.activityMsg.context ?? '{}'
            )

            data.activityMsgConfig.activityMsg.payType = JSON.parse(
                data.activityMsgConfig.activityMsg.payType ?? '{}'
            )
        } catch {
            //
        }

        activityConfig = data
        return activityConfig ?? {}
    }

    return {
        getActivityConfig,
    }
}
